export const MODULE: string = 'carousel'

export const KEY: string = 'carousel'
export const FETCH_CAROUSEL: string = `${MODULE}/${KEY}`
export const CLEAR_CAROUSEL: string = `${MODULE}/${KEY}-clear`
